export const criteriaSteps = {
  criteriaSelect: 'criteriaSelect',
  criteriaResult: 'criteriaResult',
};
